import React, { useMemo } from 'react';
import { AccordionDetails } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AccountData, PassOut } from '../../../../api';
import { Accordion, AccordionSummary } from '../../../../calendar/dialogs/EditOrderDialog/components/Accordion';
import { useAuth } from '../../../../session/InternalAuthProvider';
import { PassActivityLog } from '../../PassActivityLog';
import { PassDetailPanels } from '../../PassDetailTypes';

type Props = {
  pass: PassOut;
  expandedPanel: PassDetailPanels | undefined;
  onPanelChange: (panel: PassDetailPanels) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
};

export const ActivityLogPanel = ({ pass, expandedPanel, onPanelChange }: Props) => {
  const { t } = useTranslation();
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;
  const usersById = useMemo(
    () => new Map((account.users ?? []).map((u) => [u.user_id, `${u.first_name} ${u.last_name}`])),
    [account.users],
  );

  return (
    <Accordion
      expandedPanelName={expandedPanel}
      panelName={PassDetailPanels.ActivityLog}
      onChange={onPanelChange}
      allOpenValue={PassDetailPanels.AllOpen}>
      <AccordionSummary title={t('passes.activity_log')} />
      <AccordionDetails>
        <PassActivityLog
          passId={pass.id}
          expanded={expandedPanel === PassDetailPanels.ActivityLog || expandedPanel === PassDetailPanels.AllOpen}
          passUpdatedAt={pass.updated_at}
          usersById={usersById}
          account={account}
        />
      </AccordionDetails>
    </Accordion>
  );
};
